import Vue from 'vue'
import App from './App'
import router from './router'
import './core/use'
import store from './store'
import i18n from './locales'
import 'v-tooltip/dist/v-tooltip.css'
import './styles/index.less'

import bootstrap from './core/bootstrap'
import './permission' // permission control
// import '@/config/downloadSocktConfig'
Vue.config.productionTip = false
// 环境变量
Vue.prototype.$env = process.env.NODE_ENV
Vue.prototype.$gray = process.env.SSO_ENV
// 业务变量
Vue.prototype.$showYST = store.state.showYST
Vue.prototype.antPrefix = 'home-ant'
// window.VueByHome = window.Vue
// delete window.Vue
window.VueByHome = window.Vue
delete window.Vue

const app = new Vue({
  data: {
    windowMode: {}
  },
  router,
  store,
  i18n,
  // init localstorage, vuex
  created: bootstrap,
  render: h => h(App)
}).$mount('#container')

export default app
